export default __webpack_public_path__ + "static/media/franco.7c5b96a2.Jpg";